'use client';

import { useSelectedStoreId } from '@/lib/stores/store-context';
import { ItemForm } from '../item-form';

export default function NewItemPage() {
  const storeId = useSelectedStoreId();
  if (!storeId) return null;
  return <ItemForm storeId={storeId} />;
}
